"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const row_1 = __importDefault(require("antd/lib/row"));
const Alignment_1 = require("../Icons/PropTypes/Alignment");
/**
 * Props for this component.
 * @typedef {{
 *  children?: React.ReactNode,
 *  className?: string,
 *  style?: React.CSSProperties,
 *  gutter?: string | number,
 *  valign?: string,
 * }} RowProps
 */
/**
 * @param {RowProps} [props] Props for this component.
 * @return {JSX.Element} JSX Element
 */
const Row = (_a) => {
    var { children, className, gutter, valign } = _a, props = __rest(_a, ["children", "className", "gutter", "valign"]);
    const classes = (0, classnames_1.default)("gerudo-row", className);
    const gutters = gutter === "small" ? [16, 16] : [32, 32];
    return (react_1.default.createElement(row_1.default, Object.assign({ className: classes, gutter: gutter && gutters, align: valign }, props), children));
};
exports.Row = Row;
Row.defaultProps = {
    justify: "start",
    valign: "top",
};
Row.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.arrayOf(prop_types_1.default.node)]).isRequired,
    className: prop_types_1.default.string,
    gutter: prop_types_1.default.oneOfType([prop_types_1.default.any, prop_types_1.default.oneOf(["small", "large"])]),
    justify: Alignment_1.HorizontalAlignPropTypes,
    valign: Alignment_1.VerticalAlignPropTypes,
    style: prop_types_1.default.any,
};
exports.default = Row;
//# sourceMappingURL=index.js.map